<ion-avatar>

    <ion-img *ngIf="Data?.Url" [src]="Data?.Url" style="cursor: pointer;" alt="imagem"
        (click)="OnPresentImage($event)"></ion-img>

</ion-avatar>